import { forwardRef, useRef } from 'react';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';

const DraggableDialogWrapper = forwardRef(function DraggableDialogWrapper(props, ref) {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle=".MuiDialogTitle-root"
      cancel='[class*="MuiDialogContent-root"], .MuiIconButton-root'
    >
      <Paper
        {...props}
        ref={(el) => {
          nodeRef.current = el;
          if (typeof ref === 'function') {
            return ref(el)
          }else if (ref) ref.current = el;
        }}
      />
    </Draggable>
  );
});

export default DraggableDialogWrapper;
